export const LICENCE_RANGES = {
	TOWER_LIFT: "TOWER_LIFT",
	TOWER_CONTROL: "TOWER_CONTROL",
	TOWER: "TOWER",
	BRIDGE: "BRIDGE"
} as const;

export const OLD_LICENCE_RANGES = new Set<string>([LICENCE_RANGES.TOWER]);
export const NEW_LICENCE_RANGES = new Set<string>([
	LICENCE_RANGES.TOWER_LIFT,
	LICENCE_RANGES.TOWER_CONTROL,
	LICENCE_RANGES.BRIDGE
]);

export const CONTROL_RANGES = new Set(["CONTROL", "TOWER_CONTROL"]);
